import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CopyIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useEventTypeContext } from 'features/event_type_provider';
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction';
import { idSelector, isAdminOrOwnerSelector } from 'selectors/current_user';
import { useFormHandleSubmit } from '../../../../../../hooks';
import { DropdownContent } from '../copy_from_to';
const menuContainerCss = "m1k180o8";
const MenuContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuContainerCss, props.className)} />;
});
export const MoreOptions = ({
  handleRollbackToDefault,
  userId,
  ...props
}) => {
  const menuButtonRef = useRef();
  const {
    eventType,
    isCreation
  } = useEventTypeContext();
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector);
  const currentUserId = useSelector(idSelector);
  const formHandleSubmit = useFormHandleSubmit({
    validateOnly: isCreation
  });
  const [toggleCopyFromTo, CopyFromToDropdown] = useDropdown();
  const isCurrentUserAvailability = currentUserId === userId;
  const showApplyFromTo = isCurrentUserAvailability || isOwnerOrAdmin;
  const trackETEAvailabilityInteraction = useTrackAvailabilityInteraction({
    eventType,
    location: 'et_editor'
  });
  const toggleWithBlur = toggleFn => () => {
    toggleFn();
    if (menuButtonRef.current) {
      menuButtonRef.current.blur();
    }
  };
  const toggleCopyFromToAndBlur = toggleWithBlur(toggleCopyFromTo);
  const handleOpenSearch = () => {
    formHandleSubmit();
    trackETEAvailabilityInteraction({
      action: 'apply_to_from_event_types'
    });
    toggleCopyFromTo();
  };
  if (!showApplyFromTo) {
    return null;
  }
  return <MenuContainer {...props}>
      <IconButton size="small" title={I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.menu.copy_from_to')} onClick={handleOpenSearch}>
        <CopyIcon />
      </IconButton>
      <CopyFromToDropdown>
        <DropdownContent toggleDropdown={toggleCopyFromToAndBlur} userId={userId} />
      </CopyFromToDropdown>
    </MenuContainer>;
};

require("./more_options.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./more_options.js");